import module from '../../shared.module';
import moment from 'moment';
import _ from 'lodash';

module.component('giftList', {
  // isolated scope binding
  bindings: {
    personId: '<',
  },

  // Inline template which is binded to message variable
  // in the component controller
  templateUrl: 'app/shared/components/gift-list/gift-list.tpl.html',

  // The controller that handles our component logic
  controller: [
    'GiftListService',
    'FriendsService',
    '$state',
    '$rootScope',
    '$timeout',
    'CurrentUserService',
    function (GiftListService, FriendsService, $state, $rootScope, $timeout, CurrentUserService) {
      var ctrl = this;
      var personId = ctrl.personId | 0;
      var friendList;

      ctrl.isSelfGiftList = CurrentUserService.currentUser.id == personId;

      FriendsService.friends.then(function (data) {
        friendList = data;

        if (!ctrl.isSelfGiftList) {
          FriendsService.getFriendById(personId).then(function (friend) {
            ctrl.giftListPersonName = `${friend.name} doesn\'t`;
          });
        } else {
          ctrl.giftListPersonName = "You don't";
        }
      });

      ctrl.getRelativeDateTime = function (dt) {
        return moment(dt).fromNow();
      };

      ctrl.giftListForEveryone = function () {
        return personId == 0;
      };

      ctrl.getGiftFor = function (gift) {
        var friend = _.find(friendList, { id: gift.giftFor });
        return friend.name;
      };

      ctrl.getDescription = function (gift) {
        var maxLength = 200;

        if (!gift.description) {
          return '';
        }

        if (gift.description.length > maxLength) {
          return `${gift.description.substring(0, maxLength)}...`;
        } else {
          return gift.description;
        }
      };

      GiftListService.listFor(personId).then(function (data) {
        ctrl.list = data;

        if ($state.$current.scrollPosition) {
          $timeout(
            function () {
              //window.scrollTo(0, $state.$current.scrollPosition);
            },
            0,
            false
          );
        }
      });

      $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams, options) {
        $state.$current.scrollPosition = window.scrollY;
      });
    },
  ],
});
